import { useEffect, useState } from "react";
import { Dropdown, Table, Button } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { useTranslate } from "../hooks/LanguageProvider";
import ModalNewDeadline from "../components/Program/NewProgram";
import ModalNewSite from "../components/Program/NewSite";
import ModalViewPrograms from "../components/Program/ModalViewPrograms";
//import CalendarDeadlineModal from "../components/Program/CalendarProgram";
import ModalShowSite from "../components/Program/ShowSite";
import { PropagateLoader } from "react-spinners";
import EditProgramModal from "../components/Program/EditProgram";
import ModalEditSite from "../components/Program/EditSite";
import ModalDeleteProgram from "../components/Program/DeleteProgram";
import ModalDeleteSite from "../components/Program/DeleteSite";

//import  useRef from "react-bootstrap";
//import { Calendar } from "react-big-calendar";
//import FullCalendar from "@fullcalendar/react";
//import dayGridPlugin from "@fullcalendar/daygrid";
//import timeGridPlugin from "@fullcalendar/timegrid";
//import listPlugin from "@fullcalendar/list";
//import frLocale from "@fullcalendar/core/locales/fr";
//import enLocale from "@fullcalendar/core/locales/en-gb";
//import esLocale from '@fullcalendar/core/locales/es';
//import arLocale from "@fullcalendar/core/locales/ar";
//import interactionPlugin from "@fullcalendar/interaction";
import {
  DownloadModal,
  generateExcelFile,
  generatePDFFile,
  handleDownloadConfirm,
  addHiddenColumn,
  removeHiddenColumn,
  getHiddenColumns,
} from "../utilities/functions";

//import { set } from "lodash";
import { toast } from "react-toastify";
import moment from "moment";

interface SiteInterface {
  id_site: number;
  name: string;
  location: string | null;
  id_user: number;
}


interface ProgramInterface {
  id_program: number;

  //   // Foreign Keys
  id_client: number;
  id_conducteur: number;
  id_vehicle: number;
  id_user: number;
  id_site?: number;
  //   // Program Details
  program_date: string;       // YYYY-MM-DD
  departure?: string;
  destination?: string;
  type?: string;
  observation?: string;

  //   // Status & Audit
  status: 'planned' | 'in_progress' | 'completed' | 'canceled';
  created_at: string;
  updated_at?: string | null;

  //   // Extra fields (JOIN)
  nom_conducteur?: string;
  prenom_conducteur?: string;
  //   telephone_conducteur?: string;     
  immatriculation_vehicule?: string;
  client_name?: string;
  site?: string;
  name?: string;

  //   marque_vehicule?: string;          
  //   modele_vehicule?: string;
  //   nom_user: string;          
  //   prenom_user: string;
  //   username_user: string;     
}



export function Sites() {
  const refreshData = () => {
    getSites(limit, currentPage, search, type, column, sort);
  };
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  //const { id_alarm } = useParams<{ id_alarm?: string }>(); Legacy
  //const { id_type } = useParams<{ id_type?: string }>(); Legacy
  //const typeId = id_type ? parseInt(id_type, 10) : null; (Legacy) for deadline filtering safe to remove if no calendar features
  const { translate } = useTranslate(); //lang unused

  const [sites] = useState<any[]>([]);
  const [selectedSiteId, setSelectedSiteId] = useState<number | null>(null);
  const [selectedSiteName, setSelectedSiteName] = useState<string | null>(null);

  //TODO: Legacy FullCalendar feature currently not in use
  /*const localeMap = {
    en: enLocale,
    fr: frLocale,
    ar: arLocale,
    es: esLocale,
  };*/

  const [list_Program, setProgram] = useState<SiteInterface[]>([]);
  const id_user = localStorage.getItem("userid");
  const PAGE_ID = 86;
const id_user_number = Number(id_user ?? 0);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState(10);
  const [type, setType] = useState(id_user === "1" ? 0 : 1);
  const [typeSearch, setTypeSearch] = useState(
    id_user === "1" ? translate("ID Site") : translate("Site") // Default to "Site" for non-admins
  );
  const [search, setSearch] = useState("");
  const [column, setSortColumn] = useState("id_program");
  const [sort, setSort] = useState("DESC");
  const [total, setTotal] = useState(0);
  const [selectedProgramId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [pageCount, setPageCount] = useState(0);
  const [isGridView, setIsGridView] = useState(true);
  //const [events, setEvents] = useState<any[]>([]); (Legacy) for deadline filtering safe to remove if no calendar features
  //TODO: re enable when CalendarDeadlineModal is restored
  //const [currentView, setCurrentView] = useState("dayGridMonth"); // Vue par défauts
  //type ModeType = "create" | "edit" | "yourModeValue"; 
  //const [mode, setMode] = useState<ModeType>("create");

  const [selectedDeadlines, setSelectedDeadlines] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  const [showViewProgramsModal, setShowViewProgramsModal] = useState(false);


  const onDownloadConfirm = (format: string) => {
    if (selectedDeadlines.length > 0) {
      handleDownloadConfirm(format, downloadProgramExcel, downloadProgramPDF);
    } else {
      toast.warn("Please select at least one driver", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };



  const programHeaders = [
    //translate("ID"),
    translate("ID Site"),
    translate("Site"),
    translate("Location"),
    //translate("Client"),
    //translate("Departure"),
    //translate("Destination"),
    //translate("Type"),
    //translate("Driver"),
    //translate("Vehicle"),
    //translate("Observation"),
    //translate("Status"),
  ];



  const downloadProgramExcel = () => {

    const selectedData = list_Program
      .filter((p) =>
        p.id_site != null &&
        selectedDeadlines.includes(String(p.id_site))
      )
      .map((program) => [
        String(program.id_site),
        program.location || "",
        program.name || "",
      ]);


    generateExcelFile(translate("List") + ' ' + translate("Sites"), programHeaders, selectedData);
  };

  const downloadProgramPDF = () => {

    const selectedData = list_Program
      .filter((p) =>
        p.id_site != null &&
        selectedDeadlines.includes(String(p.id_site))
      )
      .map((program) => [
        String(program.id_site),
        program.location || "",
        program.name || "",
      ]);


    generatePDFFile(translate("List") + ' ' + translate("Sites"), programHeaders, selectedData);
  };




  //TODO: Legacy FullCalendar feature currently not in use
  /*const calendarRef = useRef<FullCalendar | null>(null);
  const changeView = (view: string) => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.changeView(view);
      setCurrentView(view);
    }
  };
  const viewTranslations: Record<string, string> = {
    timeGridDay: "day",
    timeGridWeek: "week",
    dayGridMonth: "month",
    listYear: "year",
  };*/

  // Define the calendar events (empty for now)
  const initialColumns = {
    /*id_program: true,
    nom_type: true,
    date_deadline: true,
    date_creation: true,
    id_item: true,
    program_date: true,*/
    program_date: true,
    id_program: true,
    id_site: true,
    site: true,
    departure: true,
    destination: true,
    type: true,
    observation: true,
    status: true,
    nom_conducteur: true,
    immatriculation_vehicule: true,
    client_name: true,
  };

  const [selectedColumns, setSelectedColumns] = useState({
    /*id_program: true,
    nom_type: true,
    date_deadline: true,
    date_creation: true,
    id_item: true,*/
    id_program: true,
    id_site: true,
    program_date: true,
    site: true,
    departure: true,
    destination: true,
    type: true,
    observation: true,
    status: true,
    nom_conducteur: true,
    immatriculation_vehicule: true,
    client_name: true,
  });
  useEffect(() => {
  (async () => {
    if (!id_user_number) return;
    try {
      const hidden = await getHiddenColumns(id_user_number, PAGE_ID);
      setSelectedColumns((prev: any) => {
        const next = { ...prev };
        hidden.forEach((key: string) => {
          if (key in next) next[key] = false;
        });
        return next;
      });
    } catch (e) {
      console.error(e);
    }
  })();
}, [id_user_number]);


  const handleColumnChange = async (column: string) => {
  if (!id_user_number) return;

  const currentlyVisible = !!(selectedColumns as any)[column];
  const nextVisible = !currentlyVisible;

  setSelectedColumns((prev: any) => ({ ...prev, [column]: nextVisible }));

  try {
    if (!nextVisible) {
      await addHiddenColumn({ id_user: id_user_number, id_page: PAGE_ID, column_name: column });
    } else {
      await removeHiddenColumn({ id_user: id_user_number, id_page: PAGE_ID, column_name: column });
    }
  } catch (e) {
    console.error(e);
    setSelectedColumns((prev: any) => ({ ...prev, [column]: currentlyVisible }));
  }
};

  const columnMap: Record<string, string> = {
    site: "name",
  };
  const handleSortingColumn = (currentColumn: string) => {
    const backendColumn = columnMap[currentColumn] || currentColumn;
    const nextSort = sort === "ASC" ? "DESC" : "ASC";
    setSortColumn(backendColumn);
    setSort(nextSort);
    getSites(limit, currentPage, search, type, backendColumn, nextSort);
  };



  //const [selectedEvent, setSelectedEvent] = useState(null);
  const [showNewDeadlineModal, setShowNewDeadlineModal] = useState(false);
  const [showEditDeadlineModal, setShowEditDeadlineModal] = useState(false);
  //const [showCalendarDeadlineModal, setShowCalendarDeadlineModal] = useState(false); (Legacy) unused, part of old calendar modal logic


  const [showDeleteDeadlineModal, setShowDeleteDeadlineModal] = useState(false);
  const handleShowNewDeadlineModal = () => setShowNewDeadlineModal(true);
  const handleCloseNewDeadlineModal = () => {
    setShowNewDeadlineModal(false);
    setSelectedSiteId(null); //to reset the selected site ID
  };


  //Site state and handlers
  //Site Create
  const [showNewSiteModal, setShowNewSiteModal] = useState(false);
  const handleShowNewSiteModal = () => setShowNewSiteModal(true);
  const handleCloseNewSiteModal = () => setShowNewSiteModal(false);
  //Site delete
  const [showDeleteSiteModal, setShowDeleteSiteModal] = useState(false);
  const handleDeleteSiteModal = (id: number) => {
    setSelectedSiteId(id);
    setShowDeleteSiteModal(true);
  };
  const handleCloseDeleteSiteModal = () => {
    setShowDeleteSiteModal(false);
    setSelectedSiteId(null);
  };
  //Site display details  
  const [showShowSiteModal, setshowShowSiteModal] = useState(false);
  const handleshowShowSiteModal = (id: number) => {
    setSelectedSiteId(id);
    setshowShowSiteModal(true);
  };
  const handleCloseShowSiteModal = () => setshowShowSiteModal(false);
  //Site Edit
  const [showEditSiteModal, setShowEditSiteModal] = useState(false);
  const [siteToEdit, setSiteToEdit] = useState<any | null>(null);
  const [, setLoadingSite] = useState(false); //loadingSite unused
  // handler
  const handleEditSiteModal = async (id: number) => {
    setSelectedSiteId(id); // kept existing behaviour, might remove if not needed later
    // try local cache 
    const cached = sites.find((s) => s.id_site === id);
    if (cached) {
      setSiteToEdit(cached);
      setShowEditSiteModal(true);
      return;
    }
    const site = await fetchSiteById(id);
    if (site) {
      setSiteToEdit(site);
      setShowEditSiteModal(true);
    } else {
      // open modal empty or show toast
      setSiteToEdit(null);
      setShowEditSiteModal(true);
    }
  };
  const handleCloseEditSiteModal = () => {
    setShowEditSiteModal(false);
    setSelectedSiteId(null);
    setSiteToEdit(null);
  };



  const handleCloseDeleteDeadlineModal = () =>
    setShowDeleteDeadlineModal(false);

  const handleCloseEditDeadlineModal = () => setShowEditDeadlineModal(false);
  /*const handleCalendarDeadlineModal = (id: number) => {
    setselectedProgramId(id);
    setShowCalendarDeadlineModal(true);
  };
  const handleCloseCalendarDeadlineModal = () =>
    setShowCalendarDeadlineModal(false);*/



  //helper to fetch one site
  const fetchSiteById = async (id_site: number) => {
    try {
      setLoadingSite(true);
      const res = await fetch(`${backendUrl}/api/site/details/${id_site}`, {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
      if (!res.ok) throw new Error("Failed to fetch site");
      const json = await res.json();
      // endpoint may return array or object
      return Array.isArray(json) ? json[0] : json;
    } catch (err) {
      console.error("fetchSiteById error:", err);
      return null;
    } finally {
      setLoadingSite(false);
    }
  };

  /*const getDeadlines = async (
    limitValue: number,
    currentPage: number,
    search: string,
    type: number,
    column: string,
    sort: string
  ) => {
    try {
      setLoading(true);

      // Preparing the data to send
      const bodyData = JSON.stringify({
        limitValue,
        currentPage,
        search,
        type,
        id_user,
        column,
        sort,
      });

      // Retrieve the total number of pages
      const totalPagesResponse = await fetch(
        `${backendUrl}/api/program/totalpage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: bodyData,
          mode: "cors",
        }
      );

      const totalPagesJson = await totalPagesResponse.json();
      const total = totalPagesJson[0]["count"];
      setTotal(total);

      // Retrieve driver data
      const DriversResponse = await fetch(
        `${backendUrl}/api/program/search`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: bodyData,
          mode: "cors",
        }
      );

      const data = await DriversResponse.json();
      setPageCount(Math.ceil(total / limitValue));
      setLimit(limitValue);
      setProgram(data);


      // Formatter les données pour FullCalendar
      const formattedDeadlines = data.map((deadline: any) => ({
        id: deadline.id_program || "Sans ID",
        title: generatePlainTextDescription(deadline) || "Sans titre",
        start: deadline.date_deadline
          ? moment(deadline.date_deadline).format("YYYY-MM-DD")
          : null,
        end: deadline.date_creation
          ? moment(deadline.date_creation).format("YYYY-MM-DD")
          : null,
        type: deadline.nom_type,
        color: getColorByType(deadline.id_type),

      }));

      setEvents(formattedDeadlines)



      return data;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };*/
  const getSites = async (
    limitValue: number,
    currentPage: number,
    search: string,
    type: number,
    column: string,
    sort: string
  ) => {
    try {
      setLoading(true);

      const bodyData = JSON.stringify({
        limitValue,
        currentPage,
        search,
        type,
        column,
        sort
      });

      //console.log("Fetching sites with POST:", bodyData);

      const res = await fetch(
        `${backendUrl}/api/site/search`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: bodyData,
          credentials: "include",
        }
      );

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`Failed to fetch sites: ${errorText}`);
      }

      const data = await res.json();
      console.log("Sites received:", data);
      setProgram(data);

      const totalResponse = await fetch(
        `${backendUrl}/api/site/totalpage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id_user,
            search,
            type,
          }),
          credentials: "include",
        }
      );

      if (totalResponse.ok) {
        const totalData = await totalResponse.json();
        const total = totalData[0]?.count || 0;
        setTotal(total);
        setPageCount(Math.ceil(total / limitValue));
      }
    } catch (err) {
      console.error("Error fetching sites:", err);
      setProgram([]);
      setTotal(0);
      setPageCount(0);
    } finally {
      setLoading(false);
    }
  };




  useEffect(() => {
    getSites(limit, currentPage, search, type, column, sort);
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

  const handleTypeSearch = (selectedValue: string) => {
    let newType = 0;

    switch (selectedValue) {
      case translate("ID"):
        newType = 0;
        break;
      case translate("Site"):
        newType = 1;
        break;
      case translate("Location"):
        newType = 2;
        break;
      default:
        console.log("Unknown selection");
        break;
    }

    // Clear the search input when changing type
    setSearch("");
    setType(newType);
    setTypeSearch(selectedValue);
    setCurrentPage(1);

    // Trigger new search with empty search term and new type
    getSites(limit, 1, "", newType, column, sort);
  };





  const menuItems = [
    //translate("ID"),
    ...(id_user === "1" ? [translate("ID Site")] : []), // only admins see ID
    //translate("Program Date"),
    //translate("Client"),
    //translate("Departure"),
    //translate("Destination"),
    //translate("Type"),
    //translate("Driver"),
    //translate("Vehicle"),
    //translate("Observation"),
    //translate("Status"),
    translate("Site"),
  ];



  /* For Full Calndar, to be deleted or uncommented
    // Adjust end dates to match FullCalendar's display
    const adjustEndDate = (events: { start: string; end: string }[]) => {
      return events.map((event) => {
        const endDate = new Date(event.end);
        endDate.setDate(endDate.getDate() + 1); // Add one day for display
        return {
          ...event,
          end: endDate.toISOString().split("T")[0],
        };
      });
    };
  
    const adjustedEvents = adjustEndDate(events);
  
    // Count events per day (using local dates)
    const countEventsPerDay = (events: { start: string; end: string }[]) => {
      const eventsPerDay: Record<string, number> = {};
  
      events.forEach((event) => {
        let currentDate = new Date(event.start);
        const endDate = new Date(event.end);
        endDate.setDate(endDate.getDate() - 1); // Adjust for FullCalendar's display
  
        while (currentDate <= endDate) {
          const dateStr = currentDate.toLocaleDateString("en-CA"); // Local date string
          eventsPerDay[dateStr] = (eventsPerDay[dateStr] || 0) + 1;
          currentDate.setDate(currentDate.getDate() + 1);
        }
      });
  
      return eventsPerDay;
    };
  
    const eventsPerDay = countEventsPerDay(adjustedEvents);
  
    // Render day cells with local dates
    const renderDayCellContent = (cellInfo: {
      date: Date;
      dayNumberText: string;
    }) => {
      const dateStr = cellInfo.date.toLocaleDateString("en-CA"); // Local date string
      const eventCount = eventsPerDay[dateStr] || 0;
  
      return (
        <div>
          <div>{cellInfo.dayNumberText}</div>
          {eventCount > 0 && <div>{eventCount} event(s)</div>}
        </div>
      );
    };*/
  const handleAdvancedSearch = async (event: any) => {
    const searchValue = event.target.value;
    setSearch(searchValue);
    setCurrentPage(1);

    //small timeout to debounce the search
    setTimeout(() => {
      getSites(limit, 1, searchValue, type, column, sort);
    }, 300);
  };
  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    setLimit(parseInt(newValue));
    setCurrentPage(1);
    await getSites(parseInt(newValue), currentPage, search, type, column, sort);
    window.scrollTo(0, 0);
  };
  const handlePageClick = async (data: any) => {
    let currentPage = data.selected + 1;
    await getSites(limit, currentPage, search, type, column, sort);
    window.scrollTo(0, 0);
  };

  /* For Full Calndar (renderEventList), to be deleted or uncommented
    const [expandedDays, setExpandedDays] = useState<{ [key: string]: boolean }>(
      {}
    );
  
    // Toggle "Voir plus"
    const handleViewMore = (date: string) => {
      setExpandedDays((prevState) => ({
        ...prevState,
        [date]: !prevState[date],
      }));
    };*/

  /*const renderEventList = (date: string) => {
    const dayEvents = events.filter((event) => event.date === date);
    const isExpanded = expandedDays[date];
    const displayedEvents = isExpanded ? dayEvents : dayEvents.slice(0, 3);

    return (
      <>
        {displayedEvents.map((event, index) => (
          <div key={index} className="event-item">
            {event.title}
          </div>
        ))}
        {dayEvents.length > 3 && (
          <button
            className="view-more-btn"
            onClick={() => handleViewMore(date)}
          >
            {isExpanded ? "Voir moins" : "Voir plus"}
          </button>
        )}
      </>
    );
  };*/


  const columnsMap = {
    //id_program: "ID",
    ...(id_user === "1" && { id_site: "ID Site" }),
    //program_date: "Program Date",
    //client_name: "Client",
    //departure: "Departure",
    //destination: "Destination",
    //type: "Type",
    //nom_conducteur: "Driver",
    //immatriculation_vehicule: "Vehicle",
    //observation: "Observation",
    //status: "Status",
    site: "Site",
  };


  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isDeadlinesSelected, setIsDeadlinesSelected] = useState(false);


  const handleSiteSelect = (siteID: string) => {
    let updatedSelectedSites: string[] = [];

    if (selectAll) {
      // If "Select All" is enabled, toggle this specific site
      updatedSelectedSites = selectedDeadlines.includes(siteID)
        ? selectedDeadlines.filter(id => id !== siteID)
        : [...selectedDeadlines, siteID];
    } else {
      // Normal selection/deselection
      if (selectedDeadlines.includes(siteID)) {
        updatedSelectedSites = selectedDeadlines.filter(id => id !== siteID);
      } else {
        updatedSelectedSites = [...selectedDeadlines, siteID];
      }
    }

    setSelectedDeadlines(updatedSelectedSites);
    setIsDeadlinesSelected(updatedSelectedSites.length > 0);
    //console.log(updatedSelectedSites);
  };

  // In the handleSelectAllDrivers function
  const handleSelectAllDrivers = (checked: boolean) => {
    setSelectAll(checked);
    //console.log(checked)
    if (checked) {
      // Select all sites - use id_site instead of id_program
      const allSiteIDs = list_Program
        .map((site) => site.id_site?.toString()) // Use optional chaining
        .filter((id): id is string => id !== undefined); // Filter out undefined values

      setSelectedDeadlines(allSiteIDs);
      setIsDeadlinesSelected(true); // Mark as selected
    } else {
      // Deselect all
      setSelectedDeadlines([]);
      setIsDeadlinesSelected(false); // Mark as unselected
    }
  };



  return (
    <>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <h4>
            {translate("Sites")} ({total})
          </h4>
        </div>
        <div className="col-md-6 col-sm-12 text-right d-flex justify-content-end">
          <button className="btn btn-outline-secondary  mt-2 mr-1" onClick={handleShowNewSiteModal}>
            {translate("Add Site")}
          </button>
          {/*<button className="btn btn-outline-secondary  mt-2 mr-1" onClick={handleShowNewDeadlineModal}>
            {translate("Add Program")}
          </button>*/}

          <button
            className="btn btn-outline-secondary  mt-2 mr-1"
            onClick={() => setShowDownloadModal(true)}
          >
            <i className="las la-download"></i>
            {translate("Export")}
          </button>

        </div>
      </div>
      <div className="row">
        <div
          className="col-md-4"
          style={{ margin: "0px 0px 10px 0px", padding: "10px" }}
        >
          <div className="input-group">
            <Dropdown>
              <Dropdown.Toggle variant="link" id="dropdown-basic">
                <i
                  className="fas fa-chevron-down"
                  style={{ fontSize: "20px" }}
                ></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {menuItems.map((item, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={() => handleTypeSearch(item)}
                    eventKey={item}
                    active={typeSearch === item}
                    className={typeSearch === item ? "select-active" : ""}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <input
              type="text"
              placeholder={`by ${translate(typeSearch)}`}
              value={search}
              onChange={handleAdvancedSearch}
              className="form-control"
            />
          </div>
        </div>
        <div className="col-md-8 d-flex justify-content-end align-items-center">
          <div className="dataTables_length">
            <label style={{ marginBottom: "0" }}>
              {translate("Show")}
              <select
                className="custom-select custom-select-sm form-control form-control-sm ml-2"
                style={{ width: "66px" }}
                onChange={handleSelectChange}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
              </select>
            </label>
          </div>
          <Dropdown>
            <Dropdown.Toggle
              variant="link"
              id="dropdown-basic"
              title="Display Columns"
            >
              <i className="las la-eye"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {Object.entries(columnsMap).map(([colKey, translation], idx) => (
                <Dropdown.Item
                  key={idx}
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns[colKey as keyof typeof initialColumns]}
                    onChange={() =>
                      handleColumnChange(colKey as keyof typeof initialColumns)
                    }
                  />
                  <span style={{ marginLeft: "10px" }}>{translate(translation)}</span>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          {/* <Button
            onClick={() => setIsGridView(!isGridView)}
            style={{
              background: "no-repeat",
              color: "#000",
              border: "1px solid #ddd",
            }}
            className={`mt-2 ${isGridView ? "active" : ""}`}
          >
            {isGridView ? (
              <>
                <i className="las la-icons"></i>
                <span>{translate("Calendar View")}</span>
              </>
            ) : (
              <>
                <i className="las la-list"></i>
                <span>{translate("List view")}</span>
              </>
            )}
          </Button> */}
        </div>
      </div>

      {isGridView ? (
        <div className="row m-1">
          <Table className="dataTable" responsive>
            <thead className="bg-white text-uppercase">
              <tr className="ligth ligth-data">
                <th>
                  <div className="form-check" style={{ float: "left" }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectAll}
                      onChange={(e) => handleSelectAllDrivers(e.target.checked)}
                    />
                    <label className="form-check-label"></label>
                  </div>
                </th>

                {selectedColumns.id_site && id_user === "1" && (<th className="sorting " onClick={() => handleSortingColumn("id_site")} > {translate("ID Site")} </th>)}
                {/*selectedColumns.id_program && id_user == "1" && (<th className="sorting " onClick={() => handleSortingColumn("id_program")} > {translate("ID")} </th>)*/}
                {/*selectedColumns.program_date && (
                  <th className="sorting" onClick={() => handleSortingColumn("program_date")}>
                    {translate("Program Date")}
                  </th>
                )*/}
                {selectedColumns.site && (
                  <th className="sorting" onClick={() => handleSortingColumn("site")}>
                    {translate("Site")}
                  </th>
                )}
                {/*selectedColumns.client_name && (
                  <th className="sorting" onClick={() => handleSortingColumn("client_name")}>
                    {translate("Client")}
                  </th>
                )*/}
                {/*selectedColumns.departure && (
                  <th className="sorting" onClick={() => handleSortingColumn("departure")}>
                    {translate("Departure")}
                  </th>
                )*/}
                {/*selectedColumns.destination && (
                  <th className="sorting" onClick={() => handleSortingColumn("destination")}>
                    {translate("Destination")}
                  </th>
                )*/}
                {/*selectedColumns.type && (<th className="sorting " onClick={() => handleSortingColumn("type")} > {translate("Type")} </th>)*/}
                {/*selectedColumns.nom_conducteur && (
                  <th className="sorting" onClick={() => handleSortingColumn("nom_conducteur")}>
                    {translate("Driver")}
                  </th>
                )*/}
                {/*selectedColumns.immatriculation_vehicule && (
                  <th className="sorting" onClick={() => handleSortingColumn("immatriculation_vehicule")}>
                    {translate("Vehicle")}
                  </th>
                )*/}
                {/*selectedColumns.observation && (
                  <th className="sorting" onClick={() => handleSortingColumn("observation")}>
                    {translate("Observation")}
                  </th>
                )*/}
                {/*selectedColumns.status && (
                  <th className="sorting" onClick={() => handleSortingColumn("status")}>
                    {translate("Status")}
                  </th>
                )*/}
                <th>{translate("Action")}</th>
              </tr>
            </thead>
            <tbody className="light-body">
              {loading ? (
                <tr style={{ textAlign: "center" }}>
                  <td className="text-center" colSpan={10}>
                    <p>
                      <PropagateLoader
                        color={"#123abc"}
                        loading={loading}
                        size={20}
                      />
                    </p>
                  </td>
                </tr>
              ) : Array.isArray(list_Program) && list_Program.length !== 0 ? (
                list_Program.map((program, index) => (
                  <tr key={index}>
                    <td>
                      <div className="form-check form-check-inline"  >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${program.id_site}`}
                          checked={selectedDeadlines.includes(program.id_site?.toString() || "")}
                          onChange={() => handleSiteSelect(program.id_site?.toString() || "")}
                        />
                        <label htmlFor={`checkbox-${program.id_site}`} className="mb-0"></label>
                      </div>
                    </td>
                    {selectedColumns.id_site && id_user === "1" && (<td>{program.id_site}</td>)}
                    {/*selectedColumns.id_program && id_user == "1" && (<td>{program.id_program}</td>)*/}
                    {/*selectedColumns.program_date && <td>{program.program_date ? moment(program.program_date).format("DD-MM-YYYY") : ''}</td>*/}
                    {selectedColumns.site && <td>{program.name || ""}</td>}

                    {/*selectedColumns.client_name && <td>{program.client_name || ""}</td>*/}

                    {/*
                    {selectedColumns.departure && <td>{program.departure}</td>}
                    {selectedColumns.destination && <td>{program.destination}</td>}
                    {selectedColumns.type && <td>{program.type}</td>}
                    {selectedColumns.nom_conducteur && (
                      <td>{`${program.nom_conducteur || ""} ${program.prenom_conducteur || ""}`}</td>
                    )}

                    {selectedColumns.immatriculation_vehicule && (
                      <td
                        id={`vehicle-${program.id_program}`}
                        style={{
                          cursor: 'pointer',
                          position: 'relative',
                          color: copiedId === program.id_program?.toString() ? '#28a745' : '#007bff',
                        }}
                        title={translate("Click to copy")}
                        onClick={() => {
                          if (program.immatriculation_vehicule && program.id_program?.toString()) {
                            copyToClipboard(program.immatriculation_vehicule, program.id_program.toString());
                          }
                        }}
                      >
                        <span
                          style={{
                            color: copiedId === program.id_program?.toString() ? '#28a745' : '#007bff',
                          }}
                        >
                          {program.immatriculation_vehicule}
                        </span>
                        {copiedId === program.id_program?.toString() && (
                          <span
                            style={{
                              position: 'absolute',
                              top: '-20px',
                              left: '50%',
                              transform: 'translateX(-50%)',
                              backgroundColor: '#28a745',
                              color: '#fff',
                              padding: '2px 5px',
                              borderRadius: '4px',
                              fontSize: '12px',
                            }}
                          >
                            {translate("Copied")}
                          </span>
                        )}
                      </td>
                    )}
                    {selectedColumns.observation && <td>{program.observation}</td>}
                    {selectedColumns.status && <td><div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      {getStatusIcon(program.status)}
                    </div></td>}
                  */}


                    {/*{selectedColumns.id_item && (
                      <td
                        id={`vehicle-${program.id_program}`}
                        style={{
                          cursor: 'pointer',
                          position: 'relative',
                          color: copiedId === program.id_program?.toString() ? '#28a745' : '#007bff',
                        }}
                        title={translate("Click to copy")}
                        onClick={() => {
                          let textToCopy = '';
                          switch (program.id_type) {
                            case 1: // Driving license (Conducteur)
                              textToCopy = `${program.prenom_conducteur} ${program.nom_conducteur}`;
                              break;
                            case 2: // Vehicle insurance
                              textToCopy = program.immatriculation_vehicule;
                              break;
                            case 3: // Maintenance
                              textToCopy = program.immatriculation_vehicule;
                              break;
                            case 4: // Training
                              textToCopy = `${program.training_prenom_conducteur} ${program.training_nom_conducteur}`;
                              break;
                            case 5: // Fire extinguisher
                              textToCopy = program.feu_immatriculation_vehicule.toString();
                              break;
                            case 6: // Technical control
                              textToCopy = program.immatriculation_vehicule;
                              break;
                            case 7: // Sticker
                              textToCopy = program.immatriculation_vehicule;
                              break;
                            case 8: // Draining
                              textToCopy = program.immatriculation_vehicule;
                              break;
                            default:
                              textToCopy = program.item_name || "N/A";
                          }

                          if (textToCopy && program.id_program?.toString()) {
                            copyToClipboard(textToCopy, program.id_program.toString());
                          }
                        }}
                      >
                        <span
                          style={{
                            color: copiedId === program.id_program?.toString() ? '#28a745' : '#007bff',
                          }}
                        >
                          {(() => {
                            switch (program.id_type) {
                              case 1: // Driving license (Conducteur)
                                return `${program.prenom_conducteur} ${program.nom_conducteur}`;
                              case 2: // Vehicle insurance
                                return program.immatriculation_vehicule;
                              case 3: // Maintenance
                                return program.immatriculation_vehicule;
                              case 4: // Training
                                return `${program.training_prenom_conducteur} ${program.training_nom_conducteur}`;
                              case 5: // Fire extinguisher
                                return program.feu_immatriculation_vehicule;
                              case 6: // Technical control
                                return program.immatriculation_vehicule;
                              case 7: // Sticker
                                return program.immatriculation_vehicule;
                              case 8: // Draining
                                return program.immatriculation_vehicule;
                              default:
                                return program.item_name || "N/A";
                            }
                          })()}
                        </span>

                        {copiedId === program.id_program?.toString() && (
                          <span
                            style={{
                              position: 'absolute',
                              top: '-20px',
                              left: '50%',
                              transform: 'translateX(-50%)',
                              backgroundColor: '#28a745',
                              color: '#fff',
                              padding: '2px 5px',
                              borderRadius: '4px',
                              fontSize: '12px',
                            }}
                          >
                            {translate("Copied")}
                          </span>
                        )}
                      </td>
                    )} */}


                    <td className="text-center">
                      <div className="d-flex justify-content-center align-items-center list-action">

                        {/* <Link
                          to={``}
                          className="badge bg-secondary text-white mr-2"
                          data-toggle="tooltip"
                          data-placement="top"
                          title={translate("Add program")}
                          onClick={() => {
                            setSelectedSiteId(program.id_site || null); // Set the selected site ID
                            handleShowNewDeadlineModal();
                          }}
                        >
                          <i
                            className="ri-add-line mr-0"
                            style={{ fontSize: "1.2em" }}
                          ></i>
                        </Link> */}


                        <Link
                          to={`/programs/${program.id_site}/${program.name}`}
                          className="badge bg-secondary text-white mr-2"
                          data-toggle="tooltip"
                          data-placement="top"
                          title={translate("Add program")}
                        >
                          <i
                            className="ri-calendar-check-line mr-0"
                            style={{ fontSize: "1.2em" }}
                          ></i>
                        </Link>



                        <Link
                          to={``}
                          className="badge bg-success mr-2"
                          data-toggle="tooltip"
                          data-placement="top"
                          title={translate("Edit")}
                          onClick={() =>
                            handleEditSiteModal(program.id_site!)
                          }
                        >
                          <i
                            className="ri-pencil-line mr-0"
                            style={{ fontSize: "1.2em" }}
                          ></i>
                        </Link>

                        {/* <Link
                          to={``}
                          className="badge bg-primary mr-2"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Détail"
                          onClick={() =>
                            handleshowShowSiteModal(program.id_site!)
                          }

                        >
                          <i
                            className="las la-eye"
                            style={{ fontSize: "1.2em" }}
                          ></i>
                        </Link> */}

                        <Link
                          to="#"
                          className="badge bg-info mr-2"
                          data-toggle="tooltip"
                          data-placement="top"
                          title={translate("View Programs")}
                          onClick={() => {
                            setSelectedSiteId(program.id_site!);
                            setSelectedSiteName(program.name!);
                            setShowViewProgramsModal(true);
                          }}
                        >
                          <i
                            className="las la-eye mr-0"
                            style={{ fontSize: "1.2em" }}
                          ></i>
                        </Link>


                        <Link
                          to={``}
                          className="badge bg-danger mr-2"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Delete"
                          onClick={() =>
                            handleDeleteSiteModal(program.id_site!)
                          }
                        >
                          <i
                            className="las la-trash"
                            style={{ fontSize: "1.2em" }}
                          ></i>
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr style={{ textAlign: "center" }}>
                  <td colSpan={Object.keys(selectedColumns).length || 10}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="row">
            <div className="col-md-6 d-flex align-items-center">
              <span>
                {translate("Displaying")} {list_Program.length} {translate("on")}{" "}
                {total}
              </span>
            </div>
            <div className="col-md-6">
              <ReactPaginate
                previousLabel={translate("previous")}
                nextLabel={translate("next")}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination justify-content-end"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
                forcePage={currentPage - 1}
              />
            </div>
          </div>
        </div>
      ) : (
        <div>
          {/* TODO: Legacy FullCalendar feature currently not in use, deprecated and kept temporarily for reference remove when confirmed obsolete
          <FullCalendar
            ref={calendarRef}
            key={adjustedEvents.length}
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              listPlugin,
              interactionPlugin,
            ]}
            locale={localeMap[lang]}
            contentHeight={600}
            initialView="dayGridMonth"
            events={adjustedEvents}
            eventClick={(info: { event: { id: number } }) =>
              handleCalendarDeadlineModal(info.event.id)
            }

            dayCellContent={renderDayCellContent}
            dayRender={(info: any) => {
              const date = info.dateStr;
              return <div className="day-cell">{renderEventList(date)}</div>;
            }}
            eventContent={(arg: any) => (
              <div title={`Type: ${arg.event.extendedProps.type}\nDate de début: ${arg.event.start}\nDate de fin: ${arg.event.end}`}>
                <b>{arg.timeText}</b>
                <span>{arg.event.title}</span>
              </div>
            )}
            customButtons={{
              backToMonth: {
                text: "Retour",
                click: () => calendarRef.current?.getApi().changeView("dayGridMonth"),
              },
            }}
            headerToolbar={{
              left: "prev,next today backToMonth",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            moreLinkClick="day"
            dayMaxEvents={true}
            dayMaxEventRows={3}
            dayMinEventRows={3}
          />*/}
        </div>
      )}

      <ModalNewDeadline //NewProgram
        show={showNewDeadlineModal}
        onHide={handleCloseNewDeadlineModal}
        id_site={selectedSiteId}
        onSuccess={refreshData}
      />
      <ModalNewSite
        show={showNewSiteModal}
        onHide={handleCloseNewSiteModal}
        onSuccess={refreshData}
      />
      {/*<CalendarDeadlineModal
        mode="create"
        show={showCalendarDeadlineModal}
        onHide={handleCloseCalendarDeadlineModal}
        id_program={selectedProgramId}
        onSuccess={refreshData}
      />
      <ModalEditDeadline
        show={showEditDeadlineModal}
        onHide={handleCloseEditDeadlineModal}
        id_program={selectedProgramId}
        onSuccess={refreshData}
      />*/}
      <EditProgramModal
        show={showEditDeadlineModal}
        onHide={handleCloseEditDeadlineModal}
        id_program={selectedProgramId}
        onSuccess={refreshData}
      />
      <ModalDeleteProgram
        show={showDeleteDeadlineModal}
        onHide={handleCloseDeleteDeadlineModal}
        id_program={selectedProgramId}
        onSuccess={refreshData}
      />
      <ModalDeleteSite
        show={showDeleteSiteModal}
        onHide={handleCloseDeleteSiteModal}
        id_site={selectedSiteId}
        onSuccess={refreshData}
      />
      <ModalShowSite //show details
        show={showShowSiteModal}
        onHide={handleCloseShowSiteModal}
        id_site={selectedSiteId}
      />
      <ModalEditSite
        show={showEditSiteModal}
        onHide={() => {
          handleCloseEditSiteModal();
          setSiteToEdit(null);
        }}
        site={siteToEdit}
        id_site={selectedSiteId}
        onSuccess={() => {
          refreshData();
          setSiteToEdit(null);
        }}
      />
      <DownloadModal
        show={showDownloadModal}
        onHide={() => setShowDownloadModal(false)}
        onDownloadConfirm={onDownloadConfirm}
      />
      <ModalViewPrograms
        show={showViewProgramsModal}
        onHide={() => setShowViewProgramsModal(false)}
        id_site={selectedSiteId || 0}
        selectedSiteName={selectedSiteName}
      />


    </>
  );
} 